module.exports = __webpack_public_path__ + "static/media/platinum.43ea60da.svg";